import React, { useState } from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Box,
  Modal,
  IconButton,
  Tabs,
  Tab,
} from '@mui/material';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import CloseIcon from '@mui/icons-material/Close';

import flavio1 from '../assets/flavio1.jpg';
import flavio2 from '../assets/flavio2.jpg';
import flavio3 from '../assets/flavio3.jpg';
import flavio4 from '../assets/flavio4.jpg';
import flavio5 from '../assets/flavio5.jpg';
import video1 from '../assets/video1.mp4';
import video2 from '../assets/video2.mp4';
import video3 from '../assets/video3.mp4';
import maisciencia from '../assets/maisciencia.mp4';

const Gallery = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentTab, setCurrentTab] = useState(0);

  const handleItemClick = (item) => {
    setSelectedItem(item);
  };

  const handleClose = () => {
    setSelectedItem(null);
  };

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: '800px',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 2,
    outline: 'none',
  };
  const photos = [
    {
      id: 1,
      title: 'Fenacam 2023',
      url: flavio1,
      description: 'Participãção no evento da Fenacan'
    },
    {
      id: 2,
      title: 'Fenacam 2023',
      url: flavio2,
      description: 'Participãção no evento da Fenacan'
    },
    {
      id: 3,
      title: 'Fenacam 2023',
      url: flavio3,
      description: 'Participãção no evento da Fenacan'
    },
    {
      id: 4,
      title: 'Fenacam 2023',
      url: flavio4,
      description: 'Participãção no evento da Fenacan'
    },
    {
      id: 5,
      title: 'Parceria',
      url: flavio5,
      description: 'Termo de parceria com a Empresa AquaCria'
    }
  ];

  const videos = [
    {
      id: 1,
      title: 'Vídeo 1',
      url: video1,
      description: 'Primeiro vídeo',
      isLocalVideo: true
    },
    {
      id: 2,
      title: 'Vídeo 2',
      url: video2,
      description: 'Segundo vídeo',
      isLocalVideo: true
    },
    {
      id: 3,
      title: 'Vídeo 3',
      url: video3,
      description: 'Terceiro vídeo',
      isLocalVideo: true
    },
    {
      id: 4,
      title: 'Projeto MaisCiência',
      url: maisciencia,
      description: 'Aula prática, trabalhando a montar projeto com Arduíno e programando o mesmo.',
      isLocalVideo: true
    }
  ];

  return (
    <Container maxWidth="lg" sx={{ mt: 2, mb: 2 }}>
      <Typography variant="h4" component="h1" gutterBottom align="center" color="primary">
        Galeria
      </Typography>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={currentTab} onChange={handleTabChange} centered>
          <Tab icon={<PhotoLibraryIcon />} label="Fotos" />
          <Tab icon={<VideoLibraryIcon />} label="Vídeos" />
        </Tabs>
      </Box>
      {currentTab === 0 ? (
        <Box sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            {photos.map((photo) => (
            <Grid item xs={12} sm={6} md={3} key={photo.id}>
              <Card 
                sx={{ 
                  height: '100%', 
                  display: 'flex', 
                  flexDirection: 'column', 
                  boxShadow: 1,
                  cursor: 'pointer',
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'scale(1.02)',
                    transition: 'all 0.2s ease-in-out'
                  }
                }}
                onClick={() => handleItemClick(photo)}
              >
                <CardMedia
                  component="img"
                  sx={{
                    height: 200,
                    objectFit: 'contain',
                    backgroundColor: '#f5f5f5'
                  }}
                  image={photo.url}
                  alt={photo.title}
                />
                <CardContent sx={{ py: 1 }}>
                  <Typography gutterBottom variant="h6" component="h2">
                    {photo.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {photo.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            ))}
          </Grid>
        </Box>
      ) : (
        <Box sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            {videos.map((video) => (
              <Grid item xs={12} sm={6} md={3} key={video.id}>
                <Card 
                  sx={{ 
                    height: '100%', 
                    display: 'flex', 
                    flexDirection: 'column', 
                    boxShadow: 1,
                    cursor: 'pointer',
                    '&:hover': {
                      boxShadow: 3,
                      transform: 'scale(1.02)',
                      transition: 'all 0.2s ease-in-out'
                    }
                  }}
                  onClick={() => handleItemClick(video)}
                >
                  <Box sx={{ position: 'relative' }}>
                    <Box
                      sx={{
                        height: 200,
                        backgroundColor: '#f5f5f5',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <video
                        style={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain'
                        }}
                      >
                        <source src={video.url} type="video/mp4" />
                      </video>
                    </Box>
                    <IconButton
                      sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        color: 'white',
                        '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.7)'
                        }
                      }}
                    >
                      <PlayArrowIcon />
                    </IconButton>
                  </Box>
                  <CardContent sx={{ py: 1 }}>
                    <Typography gutterBottom variant="h6" component="h2">
                      {video.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {video.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
      <Modal
        open={selectedItem !== null}
        onClose={handleClose}
        aria-labelledby="modal-content"
      >
        <Box sx={modalStyle}>
          <IconButton
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: 'white',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.7)'
              }
            }}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
          {selectedItem && (
            currentTab === 0 ? (
              <CardMedia
                component="img"
                sx={{
                  width: '100%',
                  height: 'auto',
                  maxHeight: '80vh',
                  objectFit: 'contain'
                }}
                image={selectedItem.url}
                alt={selectedItem.title}
              />
            ) : (
              <Box sx={{ width: '100%', maxWidth: '100%', maxHeight: '80vh' }}>
                {selectedItem.isLocalVideo ? (
                  <video
                    controls
                    style={{
                      width: '100%',
                      height: 'auto',
                      maxHeight: '80vh'
                    }}
                  >
                    <source src={selectedItem.url} type="video/mp4" />
                    Seu navegador não suporta o elemento de vídeo.
                  </video>
                ) : (                  <Box sx={{ position: 'relative', paddingTop: '56.25%', width: '100%' }}>
                    <iframe
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 'none'
                      }}
                      src={selectedItem.url}
                      title={selectedItem.title}
                      allowFullScreen
                    />
                  </Box>
                )}
              </Box>
            )
          )}
        </Box>
      </Modal>
    </Container>
  );
};

export default Gallery;
